import { Action, AnyAction, configureStore, ThunkAction, ThunkDispatch } from '@reduxjs/toolkit';
import { Api } from '../services/Api';
import RegisterSlice from './RegisterSlice';
import NotificationSlice from './NotificationSlice';
import LoaderSlice from './LoaderSlice';
import TransactionSlice from './TransactionSlice';
import AppSlice, { setupAppState } from './AppSlice';
import UserSlice from './UserSlice';
import NposSlice from './NposSlice';
import ModalSlice from './ModalSlice';
import ReceiptSlice from './ReceiptSlice';
import EncryptionSlice from './EncryptionSlice';
import Appstatus from './Appstatus';
import WalletSlice from './WalletSlice';
import axios from 'axios';
import { configUrl, env } from '../config/config';

export const store = configureStore({
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            serializableCheck: false,
        }),
    reducer: {
        transaction: TransactionSlice,
        register: RegisterSlice,
        notification: NotificationSlice,
        loader: LoaderSlice,
        app: AppSlice,
        user: UserSlice,
        npos: NposSlice,
        modal: ModalSlice,
        receipt: ReceiptSlice,
        encryption: EncryptionSlice,
        appstatus: Appstatus,
        wallet: WalletSlice,
    },
});

export type AppThunkDispatcher = ThunkDispatch<RootState, unknown, Action<string>>;
export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>
export type AppThunk<ReturnType = void> = ThunkAction<
    ReturnType,
    RootState,
    unknown,
    AnyAction
>

export const setupApplication = async (): Promise<void> => {
    await axios.get(configUrl)
        .then((resp) => {
            env.config = (resp.data);
        })
        .catch(e => {
            console.log("no config found " + e)
        });
    Api.init();
    Api.setDispatcher(store.dispatch);
    store.dispatch(setupAppState())
    
    /*
    Api.baseUrlGenerator('base').then(
        url => {
          const evtSource = new EventSource(`${env.config.priceUrl}/quote/USDT:fiatBRL?spread=1.04`);
      
          evtSource.onmessage = (event) => {
            console.dir(event);
          };

          evtSource.onerror = (event) => {
            console.log(`error`)
            evtSource.close();
          };
  
        }
    );
    */
};